import { Button } from '@/components/ui/button';
import type { useHistoryPage } from './useHistoryPage';
export function HistoryPager({ state, label }: { state: ReturnType<typeof useHistoryPage>; label: string }) {
  return (
    <nav aria-label={label} className='flex flex-wrap items-center justify-between gap-2 pt-3'>
      <Button
        size='sm'
        variant='outline'
        disabled={state.loading || state.page === 1}
        onClick={state.previous}
      >
        Previous
      </Button>
      <span className='text-xs text-muted-foreground'>Page {state.page}</span>
      <Button size='sm' variant='outline' disabled={state.loading || !state.hasNext} onClick={state.next}>
        Next
      </Button>
    </nav>
  );
}
